// extracted by mini-css-extract-plugin
export default {"background":"axrep1","external":"bxrep1","imgGap":"cxrep1"};